import classnames from 'classnames'

export interface IIcon {
  name: string
  disabled?: boolean
  active?: boolean
  size?: 'xl' | 'lg' | 'md' | 'sm' | 'xs'
}

const Icon = ({ name, disabled, active, size = 'xl' }: IIcon) => {
  return (
    <span
      className={classnames(`flex items-center icon-${name} text-${size} text-white`, {
        '!text-main-blue': active,
        'pointer-events-none opacity-50': disabled,
      })}></span>
  )
}

export default Icon
